// constant
import { REDUX_API_GATEWAY_ACTIONS } from '../constants/apiGateWayConstant';
import STORE_INITIATE_VALUE from '../constants/initialstore';

export default (state = STORE_INITIATE_VALUE.SPINNER_INITIATE, action) => {
  switch (action.type) {
    case REDUX_API_GATEWAY_ACTIONS.API_GATEWAY_FETCHING:
      return { value: true };
    case REDUX_API_GATEWAY_ACTIONS.API_GATEWAY_FETCHING_SUCCESS:
    case REDUX_API_GATEWAY_ACTIONS.API_GATEWAY_FETCHING_FAILURE:
      return { value: false };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/spinner.js